// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__luM84","title":"styles_title__TnFd3"};